import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

const FeatureSubDescription = (props) => {

  const {feature, intl, fabricatorData} = props;

  let pros = [];
  let subDescription = feature.dbFeature.subDescription;
  if (fabricatorData.isLowes && intl.messages) {
    if (intl.locale === "fr-FR" && intl.messages["transDoc.subDescription_FR." + feature.dbFeature.sharedFeatureName]) {
      subDescription = intl.formatMessage({id: "transDoc.subDescription_FR." + feature.dbFeature.sharedFeatureName})
    } else if (intl.locale === "pl-PL" && intl.messages["transDoc.customSubDescription_PL." + feature.dbFeature.sharedFeatureName]) {
      subDescription = intl.formatMessage({id: "transDoc.customSubDescription_PL." + feature.dbFeature.sharedFeatureName})
    }
  }
  if (subDescription && subDescription.length > 0) {
    pros = subDescription.split('\n').filter(n => n);
  }

  if (!pros.length) {
    return null
  }

  return (
    <ul className={"lk-subdesc" + (pros.length > 1 ? " lk-subdesc--list" : "")}>
      {pros.map((pros, index) => {
        return <li className="lk-subdesc__item" key={"pros" + index}>{pros}</li>
      })}
    </ul>
  )
};

FeatureSubDescription.propTypes = {
  feature: PropTypes.object.isRequired,
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeatureSubDescription)
)

